import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-decoration-angle-right-bottom",
  "use": "icon-decoration-angle-right-bottom-usage",
  "viewBox": "0 0 19 20",
  "content": "<symbol viewBox=\"0 0 19 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-decoration-angle-right-bottom\">\r\n<line x1=\"3\" y1=\"1\" x2=\"19\" y2=\"1\" stroke=\"white\" />\r\n<line x1=\"0.5\" y1=\"1.5\" x2=\"0.499998\" y2=\"19.5\" stroke=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol